/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* --- UKAR: blank province placeholder in the cart shipping estimator ------- */
(function () {
  var PLACEHOLDER = '---';
  function addPlaceholder(province, force) {
    if (!province || !province.options.length) return;
    if (province.options[0].value === '') return;
    if (!force && province.getAttribute('data-default')) return;
    province.insertBefore(new Option(PLACEHOLDER, ''), province.firstChild);
    province.selectedIndex = 0;
  }
  function wire() {
    var country  = document.getElementById('shipping-estimator-country');
    var province = document.getElementById('shipping-estimator-province');
    if (!country || !province || country.getAttribute('data-ukar-wired')) return;
    country.setAttribute('data-ukar-wired', '1');
    country.addEventListener('change', function () {
      setTimeout(function () { addPlaceholder(province, true); }, 0);
    });
    addPlaceholder(province, false);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', wire); }
  else { wire(); }
  document.documentElement.addEventListener('cart:refresh', function () { setTimeout(wire, 50); });
})();

/* --- UKAR: backorder notice (styles + variant sync) ----------------------- */
(function () {
  var css = ".ukar-bo{display:flex;align-items:center;gap:9px;margin:16px 0 12px;padding:10px 14px;border:1px solid rgba(78,158,115,.45);border-radius:4px;background:rgba(31,107,69,.14);color:#8FCCA8;font-size:14px;line-height:1.4}.ukar-bo b{color:#B9E3C9;font-weight:600}.ukar-bo svg{color:#4E9E73;flex:none}.ukar-bo[hidden]{display:none}.ukar-bo--line{display:inline-flex;margin:6px 0 0;padding:3px 8px;font-size:12.5px;border-radius:3px}.product-label--backorder{background:#1F6B45;color:#fff}";
  var s = document.createElement("style"); s.textContent = css;
  (document.head || document.documentElement).appendChild(s);
  function sync() {
    var nodes = document.querySelectorAll(".ukar-bo[data-ukar-bo-ids]");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var form = el.closest("form") || document;
      var input = form.querySelector("[name='id']");
      if (!input || !input.value) continue;
      var ids = (el.getAttribute("data-ukar-bo-ids") || "").split(",");
      var bo = ids.indexOf(String(input.value)) >= 0;
      el.hidden = !bo;
      var prop = el.querySelector("input[name='properties[_lead_time]']");
      if (prop) prop.disabled = !bo;
    }
  }
  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === "id") setTimeout(sync, 0);
    else setTimeout(sync, 0);
  }, true);
  ["variant:change", "variant:changed"].forEach(function (n) {
    document.documentElement.addEventListener(n, function () { setTimeout(sync, 0); });
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sync);
  else sync();
})();
